/**
 * Pure presenters of Minha Lais: status label/class maps, date formatting,
 * qualification-question helpers and consent lookups.
 */

export const WHATSAPP_STATUS_LABELS = {
  open: 'Ativa',
  connecting: 'Aguardando QR',
  pending: 'Pendente',
  close: 'Desconectada',
  offline: 'Offline',
  unknown: 'Indefinida',
};

export const WHATSAPP_STATUS_CLASSES = {
  open: 'bg-[#edfdf5] text-[#067647] border-[#b7ebce]',
  connecting: 'bg-[#fff8eb] text-[#9a5b13] border-[#f2d49b]',
  pending: 'bg-[#f5eef9] text-lais-primary border-[#e4d7f0]',
  close: 'bg-[#fff5f5] text-[#b42318] border-[#f1c9cf]',
  offline: 'bg-[#f3f4f6] text-[#4b5563] border-[#d1d5db]',
  unknown: 'bg-[#f3f4f6] text-[#4b5563] border-[#d1d5db]',
};

export const WHATSAPP_CALL_GATEWAY_STATUS_LABELS = {
  connected: 'Conectadas',
  open: 'Conectadas',
  awaiting_qr: 'Aguardando QR',
  waiting_qr: 'Aguardando QR',
  connecting: 'Conectando',
  qr_expired: 'QR expirado',
  paused: 'Pausadas',
  disconnected: 'Desconectadas',
  offline: 'Offline',
  failed: 'Falha no pareamento',
  unknown: 'Ainda não configuradas',
};

export const WHATSAPP_CALL_GATEWAY_STATUS_CLASSES = {
  connected: 'bg-[#edfdf5] text-[#067647] border-[#b7ebce]',
  open: 'bg-[#edfdf5] text-[#067647] border-[#b7ebce]',
  awaiting_qr: 'bg-[#fff8eb] text-[#9a5b13] border-[#f2d49b]',
  waiting_qr: 'bg-[#fff8eb] text-[#9a5b13] border-[#f2d49b]',
  connecting: 'bg-[#fff8eb] text-[#9a5b13] border-[#f2d49b]',
  qr_expired: 'bg-[#fff5f5] text-[#b42318] border-[#f1c9cf]',
  paused: 'bg-[#f3f4f6] text-[#4b5563] border-[#d1d5db]',
  disconnected: 'bg-[#fff5f5] text-[#b42318] border-[#f1c9cf]',
  offline: 'bg-[#f3f4f6] text-[#4b5563] border-[#d1d5db]',
  failed: 'bg-[#fff5f5] text-[#b42318] border-[#f1c9cf]',
  unknown: 'bg-[#f3f4f6] text-[#4b5563] border-[#d1d5db]',
};

export const WHATSAPP_ONBOARDING_STATUS_LABELS = {
  not_started: 'Não iniciado',
  blocked: 'Bloqueado',
  in_progress: 'Em andamento',
  needs_terms: 'Aguardando termos',
  ready: 'Pronto',
  attention_required: 'Atenção necessária',
};

export const WHATSAPP_ONBOARDING_STATUS_CLASSES = {
  not_started: 'bg-[#f3f4f6] text-[#4b5563] border-[#d1d5db]',
  blocked: 'bg-[#fff5f6] text-[#b42318] border-[#f1c9cf]',
  in_progress: 'bg-[#fff8eb] text-[#9a5b13] border-[#f2d49b]',
  needs_terms: 'bg-[#f5eef9] text-lais-primary border-[#e4d7f0]',
  ready: 'bg-[#edfdf5] text-[#067647] border-[#b7ebce]',
  attention_required: 'bg-[#fff5f6] text-[#b42318] border-[#f1c9cf]',
};

export const WHATSAPP_DISPLAY_NAME_STATUS_LABELS = {
  none: 'Sem solicitação',
  pending_meta: 'Em análise Meta',
  approved: 'Aprovado',
  rejected: 'Reprovado',
  cancelled: 'Cancelado',
};

export const WHATSAPP_DISPLAY_NAME_STATUS_CLASSES = {
  none: 'bg-[#f3f4f6] text-[#4b5563] border-[#d1d5db]',
  pending_meta: 'bg-[#fff8eb] text-[#9a5b13] border-[#f2d49b]',
  approved: 'bg-[#edfdf5] text-[#067647] border-[#b7ebce]',
  rejected: 'bg-[#fff5f6] text-[#b42318] border-[#f1c9cf]',
  cancelled: 'bg-[#f3f4f6] text-[#4b5563] border-[#d1d5db]',
};

export const CRM_STATUS_LABELS = {
  draft: 'Rascunho',
  pending_test: 'Pronto para teste',
  tested: 'Teste OK',
  active: 'CRM pronto',
  error: 'Erro no teste',
  disabled: 'Pausado',
};

export const CRM_STATUS_CLASSES = {
  draft: 'bg-[#f3f4f6] text-[#4b5563] border-[#d1d5db]',
  pending_test: 'bg-[#fff8eb] text-[#9a5b13] border-[#f2d49b]',
  tested: 'bg-[#edfdf5] text-[#067647] border-[#b7ebce]',
  active: 'bg-[#edfdf5] text-[#067647] border-[#b7ebce]',
  error: 'bg-[#fff5f6] text-[#b42318] border-[#f1c9cf]',
  disabled: 'bg-[#f3f4f6] text-[#4b5563] border-[#d1d5db]',
};

export const statusLabel = status =>
  WHATSAPP_STATUS_LABELS[status] || WHATSAPP_STATUS_LABELS.unknown;

export const statusClass = status =>
  WHATSAPP_STATUS_CLASSES[status] || WHATSAPP_STATUS_CLASSES.unknown;

export const callGatewayStatusLabel = status =>
  WHATSAPP_CALL_GATEWAY_STATUS_LABELS[status] ||
  WHATSAPP_CALL_GATEWAY_STATUS_LABELS.unknown;

export const callGatewayStatusClass = status =>
  WHATSAPP_CALL_GATEWAY_STATUS_CLASSES[status] ||
  WHATSAPP_CALL_GATEWAY_STATUS_CLASSES.unknown;

export const whatsappOnboardingStatusLabel = status =>
  WHATSAPP_ONBOARDING_STATUS_LABELS[status] ||
  WHATSAPP_ONBOARDING_STATUS_LABELS.not_started;

export const whatsappOnboardingStatusClass = status =>
  WHATSAPP_ONBOARDING_STATUS_CLASSES[status] ||
  WHATSAPP_ONBOARDING_STATUS_CLASSES.not_started;

export const whatsappDisplayNameStatusLabel = status =>
  WHATSAPP_DISPLAY_NAME_STATUS_LABELS[status] ||
  WHATSAPP_DISPLAY_NAME_STATUS_LABELS.none;

export const whatsappDisplayNameStatusClass = status =>
  WHATSAPP_DISPLAY_NAME_STATUS_CLASSES[status] ||
  WHATSAPP_DISPLAY_NAME_STATUS_CLASSES.none;

export const crmStatusLabel = status =>
  CRM_STATUS_LABELS[status] || CRM_STATUS_LABELS.draft;

export const crmStatusClass = status =>
  CRM_STATUS_CLASSES[status] || CRM_STATUS_CLASSES.draft;

export const formatDateTime = value => {
  if (!value) return 'Ainda não sincronizado';
  return new Intl.DateTimeFormat('pt-BR', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(new Date(value));
};

export const qualificationQuestionNeedsOptions = question =>
  ['single_select', 'multi_select'].includes(question.answer_type);

export const splitQualificationOptions = value =>
  value
    .toString()
    .split(/\n|,/)
    .map(item => item.trim())
    .filter(Boolean);

export const connectionRemovalLabel = connection =>
  connection?.profile_name ||
  connection?.phone_number ||
  connection?.instance_name ||
  'esta conexão';

export const consentRecordFor = (consents, purpose, channel, profile) =>
  consents.find(
    consent =>
      consent.purpose === purpose &&
      consent.channel === channel &&
      consent.profile === profile
  ) || null;

export const consentEnabled = (consents, purpose, channel, profile) =>
  (consentRecordFor(consents, purpose, channel, profile)?.status ||
    'ACTIVE') === 'ACTIVE';
